/*
 * Copyright (c) 2023 Bluemate B.V.
 */

import React from 'react';
import {onLogout} from '../../util/events';
import Header from './header';
import {DASHBOARD_ROUTE, SUBSCRIPTION_ROUTE} from '../../util/constants';
import {requestPageChangePermission} from '../../util/pageChanger';
import {useNavigate} from 'react-router';

interface Props {
    menuWidth: number;
}

export default function HeaderController(props: Props) {
    const {menuWidth} = props;
    const navigate = useNavigate();

    function onClickLogo() {
        requestPageChangePermission(() => {
            navigate(DASHBOARD_ROUTE);
        });
    }

    function onClickLogout() {
        requestPageChangePermission(onLogout);
    }

    function onUpgradeTrial() {
        requestPageChangePermission(() => {
            navigate(SUBSCRIPTION_ROUTE);
        });
    }

    return (
        <Header
            onClickLogo={onClickLogo}
            onUpgradeTrial={onUpgradeTrial}
            onClickLogout={onClickLogout}
            menuWidth={menuWidth}
        />
    );
}
